import { render, staticRenderFns } from "./create.vue?vue&type=template&id=5b196a23&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b196a23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b196a23')) {
      api.createRecord('5b196a23', component.options)
    } else {
      api.reload('5b196a23', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=5b196a23&scoped=true", function () {
      api.rerender('5b196a23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/reminder/components/create.vue"
export default component.exports